<template>
  <div class="CounterDisplay">
    <Picture :name="icon" />
    <span v-text="value" class="Number" />
  </div>
</template>

<script>
import { Picture } from 'daas-components';

export default {
  name: 'CounterDisplay',
  components: {
    Picture,
  },
  props: {
    value: {
      type: Number,
      required: true,
      default: 200,
    },
    icon: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss">
.CounterDisplay {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: rem(20);
  .Picture {
    height: rem(45);
  }
  .Number {
    font-size: rem(35);
    font-weight: 700;
    padding-left: rem(20);
  }
}
</style>
